import { generateId, getToday } from "../utils";

// ═══════════════════════════════════════════════════════════════
// FOLLOW-UP — a promessa que volta sozinha
// ═══════════════════════════════════════════════════════════════
//
// O buraco que isto fecha: marcar "sem interesse — retomar em 3 meses" gravava
// a data no parceiro e NÃO criava tarefa nenhuma. As notificações do topo só
// olhavam clientes e contratos, e a aba Tarefas só mostra o que está na tabela
// `tasks`. Ou seja: a data existia, ninguém era avisado, e a retomada só
// acontecia se alguém lembrasse de olhar o card certo no dia certo.
//
// Agora todo compromisso com data vira tarefa — e uma só: reagendar substitui
// a anterior em vez de empilhar três lembretes da mesma empresa.

export const TITULO_RETOMADA = "Retomar contato";
export const TITULO_FOLLOWUP = "Follow-up";

/** Tarefa aberta que já existe para este registro. */
export const tarefaAbertaDe = (tasks = [], refId, titulo) =>
  (tasks || []).find((t) => !t.done && t.refId === refId && String(t.title || "").startsWith(titulo));

/**
 * Agenda (ou reagenda) um compromisso. Substituir em vez de acumular é o que
 * mantém a lista de tarefas confiável: três lembretes da mesma empresa fazem
 * a pessoa parar de ler todos.
 */
export function agendar(tasks, { refId, tipo = "partner", titulo, quando, notas = "", userId, prioridade = "medium" }) {
  if (!refId || !quando) return tasks;
  const semAntiga = (tasks || []).filter((t) => !(!t.done && t.refId === refId && String(t.title || "").startsWith(titulo)));
  return [...semAntiga, {
    id: generateId(), title: titulo, type: tipo, refId, userId,
    dueDate: quando, priority: prioridade, done: false, notes: notas,
    createdAt: getToday(),
  }];
}

/** Fecha o compromisso quando o ato prometido acontece. */
export function concluirDe(tasks = [], refId, titulo) {
  return (tasks || []).map((t) => (
    !t.done && t.refId === refId && String(t.title || "").startsWith(titulo) ? { ...t, done: true } : t
  ));
}

/**
 * O que está vencido ou vence hoje, com o registro que o originou. É o que
 * alimenta o Painel do Dia e as notificações — a lista de tarefas nunca deve
 * ser a única porta, porque ninguém abre uma aba para ser lembrado.
 */
export function pendencias({ tasks = [], partners = [], clients = [], hoje = getToday() }) {
  const acharParceiro = (id) => partners.find((p) => p.id === id);
  const acharCliente = (id) => clients.find((c) => c.id === id);
  return (tasks || [])
    .filter((t) => !t.done && t.dueDate && t.dueDate <= hoje)
    .map((t) => ({
      ...t,
      atrasoDias: Math.max(0, Math.round((new Date(`${hoje}T00:00:00Z`) - new Date(`${t.dueDate}T00:00:00Z`)) / 86400000)),
      parceiro: t.type === "partner" ? acharParceiro(t.refId) : null,
      cliente: t.type === "client" ? acharCliente(t.refId) : null,
    }))
    .sort((a, b) => (a.dueDate || "").localeCompare(b.dueDate || ""));
}

/**
 * Compromissos que existem no registro mas não viraram tarefa — o passivo que
 * ficou para trás enquanto a promessa não gerava lembrete. Serve para não
 * perder a retomada de quem foi marcado antes desta correção.
 */
export function promessasSemTarefa(partners = [], tasks = []) {
  return (partners || [])
    .filter((p) => p.nextActionDate && !["ativo", "recusado"].includes(p.stage))
    .filter((p) => !tarefaAbertaDe(tasks, p.id, TITULO_RETOMADA) && !tarefaAbertaDe(tasks, p.id, TITULO_FOLLOWUP))
    .map((p) => ({
      parceiro: p,
      quando: p.nextActionDate,
      titulo: p.stage === "sem_interesse" ? TITULO_RETOMADA : TITULO_FOLLOWUP,
      notas: p.nextAction || "",
    }));
}
